<template>
 <div>
  <label for = "objeto-select" class="form-label">Motivo de Baixa:</label>
  <MultiSelect
   v-model = "selectedObjeto"
   :options = "objeto"
   mode = "single"
   :searchable = "true"
   :close-on-select="true"
   valueProp = "valor"
   trackBy = "texto"
   label = "texto"
   placeHolder = "Selecione um Motivo de Baixa"
   id="item-select"
  />
 </div>
</template>

 <script lang = "ts">
  import { defineComponent, ref, onMounted, watch } from "vue";
  import servico from "@/services/patrimonio/patmotivobaixa/patmotivobaixa.service";

  interface TextoValorOpcional {
   valor: number | null;
   texto: string;
  }

  export default defineComponent({
   name: "DropDownListComponente",
   props: {
    modelValue: {
     type: Number,
     default: null,
    },
    permitirEmBranco: {
     type: Boolean,
     default: false,
    },
    textoItemEmBranco: {
     type: String,
     default: "Todos",
    },
   },
   emits:["update:modelValue", "selectedItem"],
   setup(props, { emit }) {
    const objeto = ref < TextoValorOpcional[]>([]);
    const selectedObjeto = ref < number | null>(props.modelValue); 
    const loading = ref(false);
    const fetchObjeto = async() => {
     loading.value = true;
     try {
      const result = await servico.DropDownList();
      const itens = result.map((item) => ({
       valor: item.valor,
       texto: item.texto,
      }));

      objeto.value = props.permitirEmBranco
       ? [{ valor: null, texto: props.textoItemEmBranco }, ...itens]
       : itens;

      if (!objeto.value.some((item) => item.valor === props.modelValue)) { 
       selectedObjeto.value = null;
      }
     } catch (err) {
      console.error("Erro ao carregar Motivo de Baixa:", err);
     } finally {
      loading.value = false;
     }
    };
    
    watch(
     () => props.modelValue,
     (newValue) => {
      selectedObjeto.value = newValue;
     },
     {immediate: true }
    );
    
    watch(selectedObjeto, (newValue) => {
     emit("update:modelValue", newValue);
     emit("selectedItem", objeto.value.find((item) => item.valor === newValue) ?? null);
    });
    
    onMounted(fetchObjeto);
     return {
     objeto,
     selectedObjeto,
     loading,
    };
   },
  });
 </script>
